// extracted by mini-css-extract-plugin
export default {"countdown":"Sba-z","srOnly":"Tba-z"};